import { FC } from "react";
import { Flex, Heading } from "@chakra-ui/react";
import { Trans } from "~/utils/i18next";

export const PageHeadings: FC = () => {
  return (
    <Flex align="center" direction="column" gap={5} w="full">
      <Heading variant="th-h2" textAlign="center">
        <Trans i18nKey="onboarding.activate.page.heading" />
      </Heading>
      <Heading variant="th-h5" textAlign="center">
        <Trans i18nKey="onboarding.activate.page.subheading" />
      </Heading>
    </Flex>
  );
};
